import { authFetch } from '../utils/api'; 

async function getAllAccounts(userId) {
    try {
        // ⭐ Correction : Ne pas mettre BASE_API_URL ici, authFetch s'en occupe
        const response = await authFetch.get(`/all-accounts/${userId}`);
        return response.json();
    } catch (error) {
        console.error("Erreur lors de la récupération de tous les comptes:", error.message);
        throw error;
    }
}

async function getAccountsByPerson(personId) {
    try {
        const response = await authFetch.get(`/accounts/${personId}`);
        return response.json();
    } catch (error) {
        console.error(`Erreur lors de la récupération des comptes pour la personne ${personId}:`, error.message);
        throw error;
    }
}

async function createAccount(accountData) {
    try {
        const response = await authFetch.post('/accounts', accountData);
        return response.json();
    } catch (error) {
        console.error("Erreur lors de la création du compte:", error.message);
        throw error;
    }
}

async function updateAccount(accountId, accountData) {
    try {
        const response = await authFetch.put(`/accounts/${accountId}`, accountData);
        return response.json();
    } catch (error) {
        console.error(`Erreur lors de la mise à jour du compte ${accountId}:`, error.message);
        throw error;
    }
}

const AccountService = {
    getAllAccounts,
    getAccountsByPerson,
    createAccount,
    updateAccount,
};

export default AccountService;